// extracted by mini-css-extract-plugin
module.exports = {"container":"ErrorDisplay_container__1xv4R","header":"ErrorDisplay_header__2wf06","crossmark":"ErrorDisplay_crossmark__1ri2s","icon":"ErrorDisplay_icon__3iFwT"};